module.exports = __webpack_public_path__ + "static/media/footer_4.23e5820a.png";